// components/quiz/QuizLightArea.tsx
// The quiz screens are designed light (DYEN cream and ink) even when the admin app is dark.
// The global dark overrides skip `.quiz-light`, and dropdowns and dialogs open inside it.
import React, { useCallback, useRef } from 'react';
import { App, ConfigProvider } from 'antd';
import type { ThemeConfig } from 'antd';
import { lightTheme } from '../../theme/themeConfig';

// Selected tabs read as ink with a yellow underline; yellow text on cream is too faint.
const quizTheme: ThemeConfig = {
  ...lightTheme,
  components: {
    ...lightTheme.components,
    Tabs: { ...lightTheme.components?.Tabs, itemSelectedColor: '#1A1A1A', itemActiveColor: '#1A1A1A', itemHoverColor: '#1A1A1A', inkBarColor: '#FFC200' },
  },
};

const QuizLightArea: React.FC<{ className?: string; children: React.ReactNode }> = ({ className = '', children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const container = useCallback(() => ref.current || document.body, []);

  return (
    <ConfigProvider theme={quizTheme} getPopupContainer={container}>
      <div ref={ref} data-theme="light" className={`quiz-light relative min-h-screen bg-[#FAFAF7] text-[#1A1A1A] ${className}`}>
        <App component={false}>{children}</App>
      </div>
    </ConfigProvider>
  );
};

export default QuizLightArea;
